import { Container } from "react-bootstrap";
import { Login } from "pages/auth";
import { useApp } from "common/context";

import "pages/auth/styles/Authentication.scss";

export const Authentication = props => {

    const { } = useApp();

    return (
        <div className="authentication w-100 vh-100 d-flex">
            <Container className="d-flex flex-column align-items-center justify-content-center flex-fill p-4">
                <Login />
            </Container>
        </div>
    );

};